import { TabBarProps } from "modules/tabbar";
import styles from "./statisticTapBar.module.css";


export default function StatisticTabBar({ tabs, activeTab, onTabClick }: TabBarProps) {
  return (
    <div className={styles.tabMenu}>
      {tabs.map((tab, index) => (
        <button
          key={tab.id}
          className={`
            ${styles.tabButton} 
            ${activeTab === tab.id ? styles.tabActive : ""}
          `}
          onClick={() => onTabClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
